import { useEffect, useState } from "react";

// @mui material components
import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";

// RasPm Dashboard components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDInput from "components/MDInput";
import MDSnackbar from "components/MDSnackbar";
import TableChartView from "layouts/pages/powerstations/table/components/TableChartView";

// RasPm Dashboard examples
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";

// Services
import { RequestService } from "services/RequestService";

function TableDataView() {
  const [selectedStation, setSelectedStation] = useState("");
  const [startDate, setStartDate] = useState(() => {
    const today = new Date();
    const lastMonth = new Date(today);
    lastMonth.setMonth(lastMonth.getMonth() - 1);
    return lastMonth.toISOString().split('T')[0];
  });
  const [endDate, setEndDate] = useState(() => {
    const today = new Date();
    return today.toISOString().split('T')[0];
  });
  const [stations, setStations] = useState([]);
  const [notification, setNotification] = useState({
    color: "info",
    icon: "notifications",
    title: "تنبيه",
    content: "",
    open: false,
  });

  const fetchPowerStations = async () => {
    try {
      const response = await RequestService.get("PowerStation");
      if (response.data && !response.data.error) {
        setStations(response.data.data || []);
      }
    } catch (error) {
      console.error("Error fetching power stations:", error);
      setNotification({
        color: "error",
        content: "حدث خطأ أثناء جلب بيانات المحطات",
        open: true,
      });
    }
  };

  useEffect(() => {
    fetchPowerStations();
  }, []);

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox pt={6} pb={3}>
        <Grid container spacing={6}>
          <Grid item xs={12}>
            <Card>
              <MDBox p={3}>
                <MDBox display="flex" justifyContent="space-between" alignItems="center" mb={3}>
                  <MDTypography variant="h6" fontWeight="medium">
                    جدول البيانات
                  </MDTypography>
                </MDBox>
                <MDBox 
                  p={3} 
                  sx={{ 
                    backgroundColor: ({ palette: { white }, functions: { rgba } }) => rgba(white.main, 0.8),
                    borderRadius: 3,
                    boxShadow: ({ boxShadows: { md } }) => md,
                  }}
                >
                  <Grid container spacing={3}>
                    <Grid item xs={12} md={4}>
                      <MDBox mb={2}>
                        <MDBox mb={1} ml={0.5}>
                          <MDTypography component="label" variant="caption" fontWeight="bold">
                            المحطة
                          </MDTypography>
                        </MDBox>
                        <select
                          className="form-control"
                          value={selectedStation}
                          onChange={(e) => setSelectedStation(e.target.value)}
                          style={{
                            width: '100%',
                            padding: '8px 12px',
                            border: '1px solid #ccc',
                            borderRadius: '8px',
                            fontSize: '0.875rem',
                            backgroundColor: 'white',
                            direction: 'rtl',
                            fontFamily: '"Roboto","Helvetica","Arial",sans-serif'
                          }}
                        >
                          <option value="">اختر المحطة</option>
                          {stations.map((station) => (
                            <option key={station.id} value={station.id}>
                              {station.name}
                            </option>
                          ))}
                        </select>
                      </MDBox>
                    </Grid>
                    <Grid item xs={12} md={4}>
                      <MDBox mb={2}>
                        <MDBox mb={1} ml={0.5}>
                          <MDTypography component="label" variant="caption" fontWeight="bold">
                            من تاريخ
                          </MDTypography>
                        </MDBox>
                        <MDInput
                          type="date"
                          value={startDate}
                          onChange={(e) => setStartDate(e.target.value)}
                          fullWidth
                          inputProps={{
                            style: { direction: 'rtl', textAlign: 'right' }
                          }}
                        />
                      </MDBox>
                    </Grid>
                    <Grid item xs={12} md={4}>
                      <MDBox mb={2}>
                        <MDBox mb={1} ml={0.5}>
                          <MDTypography component="label" variant="caption" fontWeight="bold">
                            إلى تاريخ
                          </MDTypography>
                        </MDBox>
                        <MDInput
                          type="date"
                          value={endDate}
                          onChange={(e) => setEndDate(e.target.value)}
                          fullWidth
                          inputProps={{
                            style: { direction: 'rtl', textAlign: 'right' }
                          }}
                        />
                      </MDBox>
                    </Grid>
                  </Grid>
                </MDBox>
                {selectedStation && (
                  <MDBox mt={3}>
                    <TableChartView 
                      powerStationId={selectedStation} 
                      startDate={startDate}
                      endDate={endDate}
                      key={`table-chart-${selectedStation}-${startDate}-${endDate}`} 
                    />
                  </MDBox>
                )}
              </MDBox>
            </Card>
          </Grid>
        </Grid>
        <MDSnackbar
          color={notification.color}
          icon={notification.icon}
          title={notification.title}
          content={notification.content}
          open={notification.open}
          onClose={() => setNotification({ ...notification, open: false })}
          close={() => setNotification({ ...notification, open: false })}
        />
      </MDBox>
      <Footer />
    </DashboardLayout>
  );
}

export default TableDataView;
